import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Icon from '../atoms/Icon';
import { DashboardTimelineType } from '../../../constants/ComponentTypes';

const styles = () => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'center',
    padding: "14px 0 15px",
    cursor: "pointer",
    boxShadow: "0px 0px 3px #00000029",
    '&:hover': {
      background: "#F2F7FF",
    },
  },

  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  title: {
    fontSize: "12px",
    color: "#181819",
    fontWeight: "bold",
  },

  peopleCount: {
    marginTop: "15px",
    fontSize: "30px",
  },

  companyCount: {
    marginTop: "10px",
    fontSize: "11px",
  }
});

class StatusItem extends React.Component {
  render() {
    const { classes, item, pageInfo, statusSelected } = this.props;

    return (
      <div
        className={classes.root}
        onClick={() => this.props.handleClick(item)}
        style={{ backgroundColor: statusSelected === item.value ? '#F2F4FF' : '' }}
      >
        <div className={classes.header}>
          <Icon type={item.value} color={item.color} backgroundColor={item.backgroundColor} />
          <Typography type="body1" className={classes.title}>{item.text === '注文受付' ? DashboardTimelineType.APPROACH.text : item.text}</Typography>
        </div>
        <Typography type="body1" className={classes.peopleCount} style={{ color: item.color }}>
          {(pageInfo[item.value] ? pageInfo[item.value].total : "-") + "人"}
        </Typography>
        <Typography type="body1" className={classes.companyCount} style={{ color: item.color }}>
          {"企業数: " + (pageInfo[item.value] ? pageInfo[item.value].corporation_count : "-") + "社"}
        </Typography>
      </div>
    )
  }
}

StatusItem.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
  pageInfo: PropTypes.object,
  statusSelected: PropTypes.number,
  handleClick: PropTypes.func,
};

export default withStyles(styles)(StatusItem);



// WEBPACK FOOTER //
// ./src/components/OrderDashboardPages/items/StatusItem.jsx